export default __webpack_public_path__ + "static/media/StoryHouse.f11f2781.png";